export const locale = {
    lang: "ca",
    data: {
        DASHBOARD: {
            Title: "Control Center",
            SwitchViews: "Canviar Vista",
            Done: "Tancar",
            EventStream: "Events",
            KioskMode: "Modo Kiosko",
            KioskModeMessage: "El mode Kiosk funciona millor en pantalla completa, vols canviar a pantalla completa?",
        },
        DEVICES: {
            ConnectedDevices: "Dispositius Connectats",
            Connected: "Connectats",
            Total: "Total",
        },
        FIELD: {
            sound_pressure_level: "Nivel Soroll (dBA)",
            sound_pressure_level_c: "Nivel Soroll (dBC)",
            sound_pressure_level_1m: "Nivel Soroll (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Nivel Soroll (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 segons (dBA)",
            rolling_5s_c: "Rolling 5 segons (dBC)",
            rolling_5: "Rolling 5 minuts (dBA)",
            rolling_5_c: "Rolling 5 minuts (dBC)",
            rolling_30: "Rolling 30 minuts (dBA)",
            rolling_30_c: "Rolling 30 minuts (dBC)",
            battery: "Bateria",
            power_supply_status: "Font d'alimetació",
            spectrum_13_octave: "Espectre 1/3 Octava",
            spectrum_13_octave_1m: "Espectre 1/3 Octava (1 min)",
            temperature: "Temperatura Ext.",
            overload: "Sobrecàrrega",
            underrange: "Underrange",
            wifi_signal_level: "Senyal WiFi",
            cellullar_signal_level: "Senyal Cel·lular",
            free_storage: "Espai Lliure",
        },
        SIDEBAR: {
            Views: "Vistes",
            Delete: "Esteu segur que voleu suprimir ?",
            AddView: "Afegir Vista",
        },
    },
};
